import { useEffect } from "react";

import { FormField } from "components/form/FormField/FormField";
import { useBMI } from "hooks/useBMI";

import style from "../ReferralForm.module.css";

export const VitalSignsAndMeasurementsFormSection = ({ form }) => {
  const height = form.watch("bodyHeight");
  const weight = form.watch("weight");
  const bmi = form.watch("bmi");
  const calculatedBmi = useBMI(height, weight);

  useEffect(() => {
    if (calculatedBmi && height !== "" && weight !== "") {
      form.setValue("bmi", calculatedBmi);
    } else if (!height && !weight && !bmi) {
      form.setValue("bmi", "");
    }
  }, [calculatedBmi, height, weight, bmi, form]);

  return (
    <div
      className={style.inputGroupGrid5Columns}
      style={{ gridTemplateColumns: "1fr 1.3fr 1fr 1fr 1fr" }}
    >
      <FormField name="pulse">
        <label className={style.addReferralFormLabel}>Pulse</label>
        <div className={style.bpmInput}>
          <input
            type="text"
            inputMode="numeric"
            className="form-control"
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
            }
            {...form.register("pulse")}
          />
        </div>
      </FormField>
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className={style.addReferralFormLabel}>
          BP Systolic/Diastolic
        </label>
        <div className={style.bpInput}>
          <FormField name="bp1">
            <div className={style.mmInput}>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                {...form.register("bp1")}
              />
            </div>
          </FormField>
          <span> / </span>
          <FormField name="bp2">
            <div className={style.hgInput}>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                {...form.register("bp2")}
              />
            </div>
          </FormField>
        </div>
      </div>
      <FormField name="bodyHeight">
        <label className={style.addReferralFormLabel}>Body Height</label>
        <div className={style.metersInput}>
          <input
            type="text"
            inputMode="numeric"
            className="form-control"
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
            }
            {...form.register("bodyHeight")}
          />
        </div>
      </FormField>
      <FormField name="weight">
        <label className={style.addReferralFormLabel}>Weight</label>
        <div className={style.kgInput}>
          <input
            type="text"
            inputMode="numeric"
            className="form-control"
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
            }
            {...form.register("weight")}
          />
        </div>
      </FormField>
      <FormField name="bmi">
        <label className={style.addReferralFormLabel}>Body Mass Index</label>
        <div className={style.kgm2Input}>
          <input
            type="text"
            inputMode="numeric"
            className="form-control"
            {...form.register("bmi")}
          />
        </div>
      </FormField>
    </div>
  );
};
